<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_3"><strong><em>The</em> DIY <em>Wedding</em></strong></a></h1><a id="page_3">
<p class="subtitle">Celebrate Your Day Your Way</p>
<p class="author"><strong><em>by Kelly Bare</em></strong></p>
<p class="author1">Foreword by Natalie Zee Drieu</p>
<p class="publisher"><img alt="publisher-image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?0b1de11d